import { Skeleton } from "@drpcrd/shared/ui";
import { cn } from "@drpcrd/utils/shared";

type Props = {
  className?: string;
};

export const CreatorCardSkeleton = ({ className }: Props) => (
  <div
    className={cn(
      "group flex flex-col justify-between overflow-hidden rounded-2xl border border-neutral-500 bg-white p-3",
      className,
    )}
  >
    <div className="flex flex-col gap-1.5">
      <Skeleton className="h-4 w-4 rounded-full sm:h-6 sm:w-6" />
      <Skeleton className="h-3 w-3/4 rounded-b-sm" />
    </div>
    <div className="flex flex-col gap-1">
      <div className="flex w-full justify-between">
        <div className="flex gap-1">
          <Skeleton className="h-2 w-2 rounded-full" />
          <Skeleton className="h-2.5 w-14 rounded-sm" />
        </div>
        <Skeleton className="h-2.5 w-6 rounded-sm" />
      </div>
      <div className="flex w-full justify-between">
        <div className="flex gap-1">
          <Skeleton className="h-2 w-2 rounded-full" />
          <Skeleton className="h-2.5 w-14 rounded-sm" />
        </div>
        <Skeleton className="h-2.5 w-6 rounded-sm" />
      </div>
    </div>
  </div>
);
